<template>
  <div>
    <h2 class="mb-2font-semibold fsize16">Select Users</h2>
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :row-key="getRowKey"
      header-row-class-name="thead-light table-th-color"
    >
      <el-table-column type="selection" width="70" :reserve-selection="true">
      </el-table-column>
      <el-table-column label="Name" width="120">
        <template v-slot="{ row }">{{
          row.name ? row.name : row.fullName
        }}</template>
      </el-table-column>
      <el-table-column property="mobile" width="180" label="Phone Number">
      </el-table-column>
      <el-table-column property="email" label="Email" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <div class="flex justify-end mt-4">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getAllUsers();
          }
        "
        :per-size="perPage"
        :total="totalUsers"
      ></el-pagination>
    </div>
    <div class="flex justify-end gap-3 mt-6">
      <div class="relative">
        <vs-button
          @click="handleAdd()"
          type="primary"
          class="rounded-full bg-primary border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
        >
          Add
        </vs-button>
      </div>
      <div class="relative">
        <vs-button
          @click="handleCancel()"
          type="secondary"
          class="rounded-full bg-secondary border-0 text-white font-medium fsize14 py-3 w-full sm-fsize14"
        >
          Cancel
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      tableData: [],
      totalUsers: 0,
      currentPage: 1,
      perPage: 10,
      value: [],
      multipleSelection: [],
      members: [],
    };
  },
  computed: {
    ...mapState("admin", ["login"]),
  },
  props: {
    segmentid: {
      type: String,
    },
  },
  methods: {
    getRowKey(row) {
      // console.log(row);
      return row._id;
    },
    handleCancel() {
      this.$emit("changeData");
      this.members.length = 0;
      this.multipleSelection = [];
    },
    async handleAdd() {
      try {
        let record = {};
        // console.log(this.segmentid);
        Object.assign(record, { segmentid: this.segmentid });

        let user = [];
        for (let i = 0; i < this.multipleSelection.length; i++) {
          user.push({ userid: this.multipleSelection[i]._id });
        }
        Object.assign(record, { user: user });
        // console.log(record);

        let addMember = await this.$store.dispatch(
          "segment/addMembers",
          record
        );

        if (addMember.code == 200) {
          this.multipleSelection = [];
          this.member = [];
          this.$emit("changeData");
        }
      } catch (err) {
        console.log(err);
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    async getAllUsers() {
      try {
        let data = await this.$store.dispatch("user/getAllUsers", {
          perPage: this.perPage,
          page: this.currentPage,
        });
        this.tableData = data.registeredUser;
        this.totalUsers = data.registeredUserLength;
        if (this.multipleSelection.length != 0) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            // this.members = this.multipleSelection;
            this.members.push(this.multipleSelection[i]);
          }
        }
        // if (this.members.length != 0) {
        //   for (let i = 0; i < this.members.length; i++) {
        //     if (this.members[i]._id == this.tableData[i]._id) {
        //       console.log(this.members[i]._id);
        //       console.log(this.tableData[i]._id);
        //       this.value.push(this.members[i]);
        //     }
        //   }
        // }
        // if (this.value.length != 0) {
        //   this.handleSelectionChange(this.value);
        // }
      } catch (err) {
        console.log(err);
      }
    },
    // async getAllUser() {
    //   try {
    //     let data = await this.$store.dispatch("user/getAllUsers", {
    //       perPage: this.perPage,
    //       page: this.currentPage,
    //     });
    //     this.tableData = data.registeredUser;
    //     this.totalUsers = data.registeredUserLength;

    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    handleSelectionChange(val) {
      // console.log(val);
      // this.multipleSelection = val[val.length - 1]._id;
      // if (val.length != 0) {
      this.multipleSelection = val;
      // }
    },
  },
  mounted() {
    this.getAllUsers();
  },
};
</script>
